import { useQuery } from '@tanstack/react-query';

const getEntriesForComponentQueryKey = componentId => ["component-framework/get-entries-for-component", componentId];
const getEntriesForComponentQuery = componentId => {
  return {
    queryKey: getEntriesForComponentQueryKey(componentId),
    // Fetching of component entries will be handled in another layer.
    // See individual clients for
    queryFn: () => [],
    enabled: false,
    staleTime: Infinity,
    gcTime: Infinity,
    meta: {
      persist: false
    }
  };
};
const useEntriesForComponent = (componentId, extraConfig) => {
  return useQuery({
    ...getEntriesForComponentQuery(componentId),
    ...extraConfig
  });
};

export { getEntriesForComponentQuery, getEntriesForComponentQueryKey, useEntriesForComponent };
//# sourceMappingURL=query.get-all.js.map
